import { Component, OnInit } from '@angular/core';
import { ObjectGroupService } from '@app/services/object-group-lines.service';
import { Router } from '@angular/router';
import {
  listSortIndicator,
  rowMatchesSearch,
  sortRows,
  toggleListSort,
} from '@app/utils/list-table-helpers';

type ObjectGroupSortField = 'objGroupShortcode' | 'objGroupName' | 'objGroupRemarks';

@Component({
  selector: 'app-object-group-list',
  templateUrl: './object-group-list.component.html',
  styleUrl: './object-group-list.component.scss'
})
export class ObjectGroupListComponent implements OnInit {

  objectGroups: any[] = [];
  displayedObjectGroups: any[] = [];
  searchText = '';
  sortField: ObjectGroupSortField = 'objGroupShortcode';
  sortAsc = true;

  constructor(private ObjectGroupService: ObjectGroupService, private router: Router) { }

  ngOnInit() {
    this.loadObjectGroups();
  }

  loadObjectGroups() {
    this.ObjectGroupService.getobjectGroupList().subscribe((data) => {
      this.objectGroups = Array.isArray(data) ? data : [];
      this.applyFilterAndSort();
    });
  }

  onSearchChange(): void {
    this.applyFilterAndSort();
  }

  setSort(field: ObjectGroupSortField): void {
    const next = toggleListSort(this.sortField, field, this.sortAsc);
    this.sortField = next.sortField as ObjectGroupSortField;
    this.sortAsc = next.sortAsc;
    this.applyFilterAndSort();
  }

  sortIndicator(field: ObjectGroupSortField): string {
    return listSortIndicator(this.sortField, field, this.sortAsc);
  }

  private applyFilterAndSort(): void {
    const q = this.searchText.trim().toLowerCase();
    let rows = this.objectGroups.filter((row) =>
      rowMatchesSearch(row, q, ['objGroupShortcode', 'objGroupName', 'objGroupRemarks']),
    );
    rows = sortRows(rows, this.sortField, this.sortAsc);
    this.displayedObjectGroups = rows;
  }

  addObjectGroup() {
    this.router.navigate(['/designer/object-group-form']);
  }

  editObjectGroupLines(objectGroup: any) {
    console.log("In edit object group lines");
    console.log(objectGroup);
    let shortcode = objectGroup.objGroupShortcode;
    console.log(shortcode);
    this.router.navigate(['/designer/object-group-lines',shortcode ]);

  }
  
}
